import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authModalsSlice";
import educatorStepsReducer from "./educatorStepsSlice";
import coursesStepsReducer from "./coursesStepsSlice";
import userDataReducer  from "./userDataSlice"
import courseReducer  from "./courseDetailsSlice"
import flagsReducer  from "./flagsSlice"
import singleCourseReducer  from "./singleCourseSlice"
import educatorReducer  from "./educatorSlice"
import errorModalReducer  from "./errorModalSlice"
import jobListingsReducer  from "./jobListingsSlice"
import blogReducer  from "./blogSlice"
import ipReducer  from "./ipSlice"
import routeReducer  from "./routeSlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    educatorSteps: educatorStepsReducer,
    userData: userDataReducer,
    courseSteps: coursesStepsReducer,
    course: courseReducer,
    flags: flagsReducer,
    educator: educatorReducer,
    singleCourse: singleCourseReducer,
    errorModal: errorModalReducer,
    jobs: jobListingsReducer,
    blog: blogReducer,
    ip: ipReducer,
    route: routeReducer,
  }
});
